<template>
  <div style="height:100%;">
    <div class="container">
      <el-card class="card-body" v-loading="isLoading">
        <div slot="header">
          <el-form  :inline="true"
                    :model="reqParams"
                    size="mini"
                    label-width="120px">
            <el-form-item label="公司名称：" prop="companyID">
              <jy-selector
                :reqUrl="companyData.reqUrl"
                :fileType="{'listKey': '', 'value': 'id', 'label': 'name'}"
                :size="companyData.size"
                :placeHolderText="companyData.placeHolderText"
                @selectionChange="onCompanySelected"
                :filterable="true">
              </jy-selector>
            </el-form-item>
          </el-form>
        </div>
        <div class="sub-content">
          <el-button size="medium" type="text" style="margin-bottom:20px;" @click="downloadXlsxByCompany">点我下载模板</el-button>
          <el-upload
            action=""
            :limit="1"
            :http-request="uploadRolePermissionFile">
            <el-button size="small" type="primary">点击上传角色权限配置表</el-button>
            <div slot="tip" class="el-upload__tip">只允许上传指定模板填写的内容</div>
          </el-upload>
        </div>
        <p style="font-size:18px;">{{resultDescription}}</p>
      </el-card>
    </div>
  </div>
</template>

<script>
import { URL_GET_ALL_COMPANY_LIST, URL_ROLE_PERMISSION_FILE_TEMPLATE } from '../../constants/url'
import jySelector from '../../components/jy-selector'
import { postRequest, getRequest } from 'utils/http-service'

export default {
  name: 'rolePermissionManagement',

  components: {
    jySelector
  },

  data () {
    return {
      companyData: {
        reqUrl: URL_GET_ALL_COMPANY_LIST,
        size: 'mini',
        placeHolderText: '请选择或搜索公司名称'
      },
      reqParams: {
        companyID: ''
      },
      isLoading: false,
      resultDescription: ''
    }
  },

  methods: {
    onCompanySelected (e) {
      console.log(this.$route.name + ' onCompanySelected()', e)
      this.reqParams.companyID = e
    },

    downloadXlsxByCompany () {
      let that = this
      console.log(that.$route.name + 'downloadXlsxByCompany()')
      that.isLoading = true
      that.resultDescription = ''

      let params = {
        orgID: that.reqParams.companyID
      }

      getRequest(URL_ROLE_PERMISSION_FILE_TEMPLATE, params, 'blob')
        .then(res => {
          try {
            let date = new Date()
            let blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob)
            downloadElement.href = href
            downloadElement.download = '角色权限配置表' + '_' + (date.getMonth() + 1) + '月' + (date.getDate()) + '日导出' + '.xlsx'
            document.body.appendChild(downloadElement)
            downloadElement.click()
            document.body.removeChild(downloadElement)
            window.URL.revokeObjectURL(href)
            that.isLoading = false
          } catch (error) {
            console.error(that.$route.name + ' downloadXlsxByCompany() err', error)
            that.resultDescription = '错误：' + error
            that.isLoading = false
          }
        })
        .catch(err => {
          that.isLoading = false
          console.error(that.$route.name + ' downloadXlsxByCompany() err', err)
          that.resultDescription = '服务器异常，请稍后重试！'
        })
    },

    uploadRolePermissionFile (params) {
      let that = this
      console.log(that.$route.name + 'uploadRolePermissionFile()')
      that.resultDescription = ''

      let form = new FormData()
      form.append('excel', params.file)
      that.isLoading = true

      postRequest(URL_ROLE_PERMISSION_FILE_TEMPLATE, form, { timeout: 10 * 60 * 1000 }) // 超时设置没起作用
        .then(res => {
          that.isLoading = false
          if (res.code !== 0) {
            that.resultDescription = `上传失败！${res.message}`
            return
          }
          that.resultDescription = '上传成功' + (!res.data ? '' : '，' + res.data)
        })
        .catch(err => {
          that.isLoading = false
          console.error(that.$route.name + ' uploadRolePermissionFile() err', err)
          that.resultDescription = '服务器异常，请稍后重试！' + err
        })
    }
  },

  created () {}
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  flex: 1;
  padding: 15px 20px;
  .card-body {
    width:100%;
    height:100%;
    overflow-y: auto;
    .sub-content {
      padding-left: 34px;
      padding-bottom: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/role-permission-management/index.vue